export const navLinks = [
   // { name: "Shipper", path: "/" },
   // { name: "Haulage Transport", path: "/company" },
   // { name: "Services", path: "/services" },
   { name: "About us", path: "/about-us" },
   { name: "Price Estimator", path: "/price-estimator" },
   { name: "Blogs", path: "/blogs" },
   { name: "Contact Us", path: "/contact" },
]

export const blogCategories = [
   { id: "all", name: "All" },
   { id: "haulage-company", name: "Haulage Company" },
   { id: "drivers", name: "Drivers" },
   { id: "good-owners", name: "Good Owners" },
   { id: "research", name: "Research" },
   { id: "trending", name: "Trending" },
   { id: "product-updates", name: "Product Updates" },
]

export const recentPosts = [
   {
      id: 1,
      title: "How Enterprises Can Cut Freight Costs by 20% With Digital Bidding",
      excerpt:
         "Traditional freight sourcing is slow and expensive. Discover how US Trucking digital bidding system helps enterprises negotiate better rates while simplifying getting cargo deals.",
      category: "Research",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&auto=format&fit=crop",
   },
   {
      id: 2,
      title: "The Future of Logistics in Africa: Why Enterprises Need Smarter Platforms",
      excerpt:
         "Progressively incentivize cooperative systems through technically sound functionalities. Credibly productivate seamless data with flexible schemas.",
      category: "Haulage Company",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&auto=format&fit=crop",
   },
   {
      id: 3,
      title: "What collectors need to know about authenticity",
      excerpt:
         "Progressively incentivize cooperative systems through technically sound functionalities. Credibly productivate seamless data with flexible schemas.",
      category: "Research",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&auto=format&fit=crop",
   },
   {
      id: 4,
      title: "Dream destinations to visit this year in Paris",
      excerpt:
         "Progressively incentivize cooperative systems through technically sound functionalities. Credibly productivate seamless data with flexible schemas.",
      category: "Drivers",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&auto=format&fit=crop",
   },
   {
      id: 5,
      title: "Breathtaking first-person photos around Europe",
      excerpt:
         "Progressively incentivize cooperative systems through technically sound functionalities. Credibly productivate seamless data with flexible schemas.",
      category: "Haulage Company",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&auto=format&fit=crop",
   },
   {
      id: 6,
      title: "What collectors need to know about authenticity",
      excerpt:
         "Progressively incentivize cooperative systems through technically sound functionalities. Credibly productivate seamless data with flexible schemas.",
      category: "Research",
      date: "Sept 2023",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&auto=format&fit=crop",
   },
]

export const blogComments = {
   1: [
      {
         author: "Fejiro Oil & Gas",
         date: "Dec 1, 2025",
         text: "I appreciate the insights shared about digital bidding. It's transforming our approach at PetroCore Energy.",
         avatarColor: "#66C97A",
      },
      {
         author: "Fejiro Oil & Gas",
         date: "Dec 1, 2025",
         text: "I appreciate the insights shared about digital bidding. It's transforming our approach at PetroCore Energy.",
         avatarColor: "#6B7EE6",
      },
      {
         author: "Fejiro Oil & Gas",
         date: "Dec 1, 2025",
         text: "I appreciate the insights shared about digital bidding. It's transforming our approach at PetroCore Energy.",
         avatarColor: "#E66BB4",
      },
   ],
   2: [
      {
         author: "Logistics Manager",
         date: "Dec 2, 2025",
         text: "Great article on the future of logistics! This really highlights the challenges we face daily.",
         avatarColor: "#66C97A",
      },
   ],
}

export const popularPosts = [
   {
      id: 1,
      title: "Tech Innovations: Tomorrow's Gadgets and Inventions",
      category: "Innovate",
      image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=200&auto=format&fit=crop",
   },
   {
      id: 2,
      title: "Flavours from Around the Globe: Culinary Adventures",
      category: "Taste",
      image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=200&auto=format&fit=crop",
   },
   {
      id: 3,
      title: "Fashion Forward: Trends, Tips, and Timeless Style",
      category: "Chic",
      image: "https://images.unsplash.com/photo-1558769132-cb1aea1f1c4c?w=200&auto=format&fit=crop",
   },
   {
      id: 4,
      title: "Adventures Across Continents: Journeys of a Lifetime",
      category: "Venture",
      image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=200&auto=format&fit=crop",
   },
   {
      id: 5,
      title: "From Sketch to Masterpiece: Artistry Unleashed",
      category: "Create",
      image: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=200&auto=format&fit=crop",
   },
   {
      id: 6,
      title: "Eco Living: Sustainable Choices for Modern Life",
      category: "Green",
      image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=200&auto=format&fit=crop",
   },
   {
      id: 7,
      title: "Digital Nomad: Living and Working Anywhere, Anytime",
      category: "Freedom",
      image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=200&auto=format&fit=crop",
   },
   {
      id: 8,
      title: "Historical Horizons: Stories from Our Collective Past",
      category: "Legacy",
      image: "https://images.unsplash.com/photo-1461360370896-922624d12aa1?w=200&auto=format&fit=crop",
   },
   {
      id: 9,
      title: "Creative Writers: Crafting Stories, One Word at a Time",
      category: "Write",
      image: "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=200&auto=format&fit=crop",
   },
]
